import axios from "axios";


export const ApiService = axios.create(
    {
        baseURL:'',
        timeout:20000
    }
)


